// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCoolingFreezingIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M4 18h16v2c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2zM20 4v12H4V4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2m-7 5 1.85-1.07c.24-.14.32-.44.18-.68a.493.493 0 0 0-.68-.18L12.5 8.14V6.01c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2.13L9.65 7.07a.493.493 0 0 0-.68.18c-.14.24-.06.54.18.68L11 9l-1.85 1.07c-.24.14-.32.44-.18.68a.495.495 0 0 0 .68.18l1.85-1.07v2.13c0 .28.22.5.5.5s.5-.22.5-.5V9.86l1.85 1.07a.495.495 0 0 0 .68-.18c.14-.24.06-.54-.18-.68z" />
  </g>
);
export default SvgCoolingFreezingIcon;
SvgCoolingFreezingIcon.displayName = 'SvgCoolingFreezingIcon';
